// packages import
import { FC, useContext, useState } from 'react'
import { Box, Button } from '@mui/material'

import { JournalEntriesContext } from '../../../../context/JournalEntriesContext'
import { CardBox } from '../../../../theme/styleComponents'
import { ContentHead } from '../../../../components/common/ContentHead'
import JournalEntriesFilters from '../../../../components/accounting/journalEntries/filters'
import { flexCenter } from '../../../../theme/styleConstants'
import { EmptyData } from '../../../../components/common/EmptyData'
import { JournalEntriesListing } from '../../../../components/accounting/journalEntries/JournalEntriesListing'
import { AuthContext } from '../../../../context'
import { hasAdminAccess } from '../../../../utils'
import AddJournalEntryModal from '../../../../components/accounting/journalEntries/add/AddJournalEntryModal'

const JournalEntries: FC = () => {
  const [isAddJournalEntryModalOpen, setIsAddJournalEntryModalOpen] = useState(false)
  const [duplicateEntryId, setDuplicateEntryId] = useState<string | null>(null)
  const { journalEntries, loading, refetch } = useContext(JournalEntriesContext)
  const { currentUser } = useContext(AuthContext)

  const isEmpty = journalEntries?.length === 0 && !loading
  const hasAdminPermissions = hasAdminAccess(currentUser)

  const renderActionButtons = () => (
    <Button variant="contained" onClick={() => setIsAddJournalEntryModalOpen(true)}>
      Add Journal Entry
    </Button>
  )

  return (
    <>
      <CardBox marginTop={3}>
        <ContentHead title="Journal" customButton={hasAdminPermissions ? renderActionButtons : undefined} />

        <JournalEntriesFilters />

        {isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
            <EmptyData title="No journal entries found" />
          </Box>
        ) : (
          <JournalEntriesListing
            journalEntries={journalEntries}
            loading={loading}
            refetch={refetch}
            onDuplicate={setDuplicateEntryId}
          />
        )}
      </CardBox>

      {hasAdminPermissions && isAddJournalEntryModalOpen && (
        <AddJournalEntryModal
          isOpen={isAddJournalEntryModalOpen}
          handleClose={() => setIsAddJournalEntryModalOpen(false)}
          refetch={refetch}
        />
      )}

      {hasAdminPermissions && duplicateEntryId && (
        <AddJournalEntryModal
          isOpen={!!duplicateEntryId}
          journalEntryId={duplicateEntryId}
          handleClose={() => setDuplicateEntryId(null)}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default JournalEntries
